import { Paths } from "@app/routes";
import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";

/**
 * A custom hook that returns a function to navigate back in the browser history.
 * If the history stack is empty, or if we are already at the fallback path,
 * it handles the navigation gracefully.
 */
export function useNavigateBack() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = useCallback(
    (fallbackPath = `/${Paths.Home}`) => {
      // Check if we are at the "top" of our defined app
      if (location.pathname === fallbackPath) {
        // Optional: Do nothing, or exit the widget/modal
      } else {
        // Go back, but if the stack is empty, jump to fallback
        if (typeof window !== "undefined" && window.history.length > 1) {
          navigate(-1);
        } else {
          navigate(fallbackPath);
        }
      }
    },
    [navigate, location],
  );

  return handleBack;
}
